import { FC, useEffect, useState } from "react";
import { Editor as TinyEditor } from "@tinymce/tinymce-react";
import { Editor as EditorType } from "tinymce";
import { VscLoading } from "react-icons/vsc";

interface Props {
    value: string;
    disabled?: boolean;
    handleChange: (articleBody: string, editor: EditorType) => void;
}

const Editor: FC<Props> = ({ value, disabled = false, handleChange }) => {
    const [loading, setLoading] = useState(true);
    const [editorLoading, setEditorLoading] = useState(true);

    useEffect(() => {
        if (typeof window !== "undefined") {
            setLoading(false);
        }
    }, []);

    return (
        <section className="editor font-text">
            {!loading && (
                <div dir="rtl">
                    <TinyEditor
                        disabled={disabled}
                        value={value}
                        onEditorChange={handleChange}
                        onLoadContent={() => setEditorLoading(false)}
                        apiKey="ntvvm0u1g9oovo3peuu4c9ep8367vbnpndrs1hub4momh2gk"
                        tinymceScriptSrc="/plugins/tinymce/tinymce.min.js"
                        init={{
                            plugins:
                                "lists advlist directionality importcss link emoticons image media code",
                            language: "fa",
                            // menubar: false,
                            statusbar: false,
                            content_css:
                                "/styles/tinymce/fonts.css, /styles/tinymce/reset.css",
                            indentation: "16px",
                            font_family_formats:
                                "اعداد انگلیسی=IRANSans,Arial,sans-serif;اعداد فارسی=IRANSansFaNum,IRANSans,sans-serif",
                            advlist_number_styles: "number",
                            advlist_bullet_styles: "circle",
                            image_class_list: [
                                {
                                    title: "رسپانسیو",
                                    value: "max-w-full mx-auto h-auto block",
                                },
                            ],
                            // color_map: ColorMap,
                            formats: {
                                // Formatting
                                bold: {
                                    inline: "strong",
                                },
                                italic: {
                                    inline: "i",
                                },
                            },
                            toolbar: [
                                // Fonts
                                {
                                    name: "fonts",
                                    items: ["fontsize", "fontfamily"],
                                },

                                // Colors
                                {
                                    name: "formatting",
                                    items: ["backcolor", "forecolor"],
                                },

                                // Formatting
                                {
                                    name: "formatting",
                                    items: ["bold", "italic", "underline"],
                                },

                                // Alignment
                                {
                                    name: "alignment",
                                    items: [
                                        "alignjustify",
                                        "alignright",
                                        "aligncenter",
                                        "alignleft",
                                    ],
                                },

                                // Directionality
                                {
                                    name: "directionality",
                                    items: ["rtl", "ltr"],
                                },

                                // Links
                                {
                                    name: "links",
                                    items: ["link", "image", "media"],
                                },

                                // Lists
                                {
                                    name: "bullist",
                                    items: ["bullist", "numlist", "emoticons"],
                                },

                                // Indentation
                                {
                                    name: "indentation",
                                    items: ["outdent", "indent"],
                                },

                                // History
                                {
                                    name: "history",
                                    items: ["undo", "redo", "code"],
                                },
                            ],
                        }}
                    />
                </div>
            )}

            {(loading || editorLoading) && (
                <div className="text-center">
                    <VscLoading className="text-xl animate-spin text-blue-500" />
                </div>
            )}
        </section>
    );
};

export default Editor;
